// extracted by css-extract-rspack-plugin
export default {"AdminNavbarRoot":"fYu4N","AdminNavLink":"hGRox"};